import { Axios } from "../../utils/axiosMiddleware";
import { SimpleCatchError } from "../../utils/Helper";

/**
 * Add-card SetupIntent (manage saved cards). The server get-or-creates the Stripe
 * Customer for the authenticated user (derived from the JWT — no id in the body,
 * which closes an IDOR seam) and returns `{ customer, ephemeralKey, setupIntent }`;
 * web confirms the `setupIntent` client_secret via a Payment Element
 * (`confirmSetup`) — no raw card data touches our DOM. Returns the response data;
 * undefined on error.
 */
export const createPaymentMethodsSheet = async () => {
  try {
    const response = await Axios.post("stripe/payment-methods-sheet", {});
    return response?.data;
  } catch (e) {
    SimpleCatchError(e);
  }
};
